<template>
  <div id="app" @mousemove="cursorListener">
    <div class="router-view">
      <div class="content">
        <router-view :key="$route.path"></router-view>
      </div>
    </div>
    <cursor-painter v-if="!mobileDevice"/>
  </div>
</template>

<script>
import CursorPainter from '@/components/CursorPainter'
import bus from '@/assets/eventBus'

document.title = 'Free Lectures'
export default {
  components: {
    CursorPainter
  },
  data () {
    return {
      mobileDevice: true
    }
  },
  created () {
    this.isMobile()
  },
  watch: {
  },
  methods: {
    isMobile () {
      if (navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)) {
        this.mobileDevice = true
      } else {
        this.mobileDevice = false
      }
    },
    cursorListener (event) {
      const X = event.clientX
      const Y = event.clientY
      bus.$emit('cursorPosCursorPaint', [X, Y])
    }
  }
}
</script>

<style lang="scss">

#app {
  width: 100%;
  height: 100%;
  user-select: none;
  background-color: black;
  .router-view {
    width: 100%;
    min-height: 100%;
    max-height: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .content {
      flex-shrink: 0;
      flex-grow: 1;
      height: 0;
      overflow: auto;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
